// removed by extract-text-webpack-plugin
module.exports = {"logout":"LogoutButton__logout___fWaqi"};